var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoupleMini(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 17,
    viewBox: "0 0 23 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "CoupleMini") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pareja"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 9.79602C10.48 9.79602 12.5 7.77602 12.5 5.29602C12.5 2.81602 10.48 0.796021 8 0.796021C5.52 0.796021 3.5 2.81602 3.5 5.29602C3.5 7.77602 5.52 9.79602 8 9.79602ZM8 2.79602C9.38 2.79602 10.5 3.91602 10.5 5.29602C10.5 6.67602 9.38 7.79602 8 7.79602C6.62 7.79602 5.5 6.67602 5.5 5.29602C5.5 3.91602 6.62 2.79602 8 2.79602Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.67 11.296H3.33C1.49 11.296 0 12.796 0 14.626V15.796C0 16.346 0.45 16.796 1 16.796C1.55 16.796 2 16.346 2 15.796V14.626C2 13.886 2.6 13.296 3.33 13.296H12.66C13.4 13.296 13.99 13.896 13.99 14.626V15.796C13.99 16.346 14.44 16.796 14.99 16.796C15.54 16.796 15.99 16.346 15.99 15.796V14.626C15.99 12.786 14.49 11.296 12.66 11.296H12.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 7.79602C14.71 7.79602 14.43 7.74602 14.17 7.65602C13.65 7.47602 13.08 7.74602 12.89 8.26602C12.71 8.78602 12.98 9.35602 13.5 9.54602C13.98 9.71602 14.49 9.80602 15 9.80602C17.48 9.80602 19.5 7.78602 19.5 5.30602C19.5 2.82602 17.48 0.796021 15 0.796021C14.48 0.796021 13.98 0.88602 13.5 1.05602C12.98 1.23602 12.71 1.81602 12.89 2.33602C13.08 2.85602 13.65 3.12602 14.17 2.94602C14.43 2.85602 14.71 2.80602 15 2.80602C16.38 2.80602 17.5 3.92602 17.5 5.30602C17.5 6.68602 16.38 7.80602 15 7.80602V7.79602Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.67 11.296H17.34C16.79 11.296 16.34 11.746 16.34 12.296C16.34 12.846 16.79 13.296 17.34 13.296H19.67C20.41 13.296 21 13.896 21 14.626V15.796C21 16.346 21.45 16.796 22 16.796C22.55 16.796 23 16.346 23 15.796V14.626C23 12.786 21.5 11.296 19.67 11.296Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoupleMini);
export default __webpack_public_path__ + "static/media/CoupleMini.9c1acd9b54ef523640bf82cad77558cb.svg";
export { ForwardRef as ReactComponent };